(() => {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('ca-enter');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  const observe = root => root.querySelectorAll('.ca-material-copy,.ca-maker-copy,.cg-selection>h2').forEach(el => observer.observe(el));
  observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();

(() => {
 const init = root => root.querySelectorAll('[data-ca-slider]').forEach(slider => {
  if(slider.dataset.ready) return;
  slider.dataset.ready='true';
  const track=slider.querySelector('.ca-slider-track');
  const controls=slider.querySelector('.ca-slider-controls');
  const buttons=[...controls.querySelectorAll('button')];
  const update=()=>{controls.hidden=track.scrollWidth<=track.clientWidth+2;buttons[0].disabled=track.scrollLeft<=2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
  buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.caStep)*(track.querySelector('article').getBoundingClientRect().width+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(track);
  update();
 });
 init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();